import React from 'react';
import Modal from 'react-modal';


const AccountModal = ({ isOpen, onRequestClose, options, selectedOptions, handleChange }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)'
        },
        content: {
          width: '50%',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }
      }}>

      <div style={{ textAlign: 'center', width: '100%' }}>
        <h2>Выбирите поля для поиска</h2>
      </div>
      <div
        className='account-search-fields'
        style={{
        margin: "50px",
        columnCount: 4,
        columnGap: "10px",
        maxHeight: "100px",
        fontSize: "medium"
      }}>
        {options.map((option) => (
          <div key={option.value}>
          <label key={option.value}>
            <input
              key={option.value}
              style={{ margin: "5px"}}
              type='checkbox'
              value={option.value}
              checked={selectedOptions.includes(option.value)}
              onChange={handleChange}
            />
            {option.label}
          </label>
          </div>
        ))}
      </div>
      <button
        type='button'
        className='filter-columns__save'
        style={{
          position: 'absolute',
          bottom: '0',
          height: '34px',
          color: '#fff',
          background: '#161021',
          width: '50%',
          right: 0,
          margin: '20px',
          borderRadius: '6px'
        }}
        onClick={onRequestClose}
      >
        Закрыть
      </button>
    </Modal>
  );
};

export default AccountModal;
